module.exports = __webpack_public_path__ + "static/media/goldman.c96937ca.png";